<template>
  <layout :showuserinfo="false" >
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="bayar()" >
  	<div class="container-fluid  h-100">
            <div class="page-wrapper-portal">
                <MenuNav />  
                <div class="card " >
                   
                    <Menu :auth="auth" :link="'carian'" />    

                    <div class="card-body card-scroll">

                        <!-- -->
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="col-lg-4">
                                    <div class="row align-items-center">
                                        <div class="col">                      
                                            <div class="input-group " >
                                                <input type="text" class="form-control " placeholder="Sila Masukkan No. Hak Milik / No. Akaun / No. Bil " aria-label="Recipient's username" aria-describedby="button-addon2" v-model="no_rujukan">
                                                <button class="btn btn-pkn" type="button" @click="carian">Carian</button>
                                            </div>    
                                        </div><!--end col-->
                                    </div>
                                </div>  <!--end row-->   
                            </div>
                            <template v-if="butirans.length > 0"> 
                            <div class="col-lg-9">
                                <div class="row justify-content-center">
                                    <div class="">
                                        <div class="card report-card">
                                            <div class="card-body">
                                            <div class="col-lg-12">
                                                <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title"><b class="text-primary">1.</b> Senarai Carian</h4>
                                                </div><!--end card-header-->
                                                <div class="card-body">
                                                    <div class="table-responsive shopping-cart">
                                                        <table class="table mb-0">
                                                            <thead>
                                                                <tr>
                                                                    
                                                                    <th class="border-top-0">Jenis Pembayaran</th>   
                                                                    <th>No. Rujukan | Nama </th>                                                  
                                                                    <th class="border-top-0 text-right">Amaun Perlu Bayar (RM)</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="dt, index in butirans">
                                                                   <template v-if="dt.bakul == 0">
                                                                   	<tr>
                                                                    <td>
                                                                       {{dt.sumber_keterangan}} 
                                                                    </td>
                                                                    <td @click="paparan(dt)" style="cursor: pointer;">{{dt.no_rujukan}} | {{dt.keterangan}}</td>
                                                                    <td class="text-right">{{$zutil.currency(dt.amaun)}}  </td>
                                                                    <td><i class="dripicons-cart" @click="pilih(dt, 1)"></i></td>                                                        
                                                                </tr>
                                                            </template></template>
                                                                <tr>
                                                                    
                                                                    <td>
                                                                        <h6>Jumlah :</h6>
                                                                    </td>
                                                                    <td></td>
                                                                    <td class="text-dark text-right"><strong>{{$zutil.currency(total_carian)}}   </strong></td>
                                                                    <td></td>
                                                                </tr>      
                                                                                                            
                                                            </tbody>
                                                        </table>

                                                            <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                                    </div><!--end re-table-->

                                                </div><!--end card-body-->
                                            </div>
                                        </div><!--end col--> 

                                        <div class="col-lg-12">
                                            <div class="card" v-if="total_pilih">
                                            <div class="card-header">
                                                <h4 class="card-title"><b class="text-primary">2.</b> Senarai Pembayaran</h4>
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                <div class="table-responsive shopping-cart">
                                                    <table class="table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th class="border-top-0" rowspan="2">Jenis Pembayaran</th>   
                                                                <th rowspan="2">No. Rujukan | Nama</th>                                                  
                                                                <th class="border-top-0 text-center" colspan="2">Amaun  (RM)</th>
                                                                <th rowspan="2"></th>
                                                            </tr>
                                                            <tr>
                                                                <th class="border-top-0 text-center">Perlu Bayar</th>
                                                                <th class="border-top-0 text-center"> Bayar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="dt, index in butirans">
                                                               <template v-if="dt.bakul == 1">
                                                               	<tr>
                                                                <td>
                                                                    {{dt.sumber_keterangan}} 
                                                                </td>
                                                                <td @click="paparan(dt)" style="cursor: pointer;">
                                                                {{dt.no_rujukan}} | {{dt.keterangan}}</td>
                                                                <td class="text-right" >{{$zutil.currency(dt.amaun)}}  </td>
                                                                <td>
                                                                    
                                                                    <z-money :validators="[validators.required]" v-model:originalValue="dt.amaun_bayar" v-on:keyup="checkAmaun(dt)" v-on:change="pilih(dt, 1)"  />
                                                                    <span class="tw-form-el__error error">{{dt.mesej}}</span>
                                                                </td>
                                                                <td><i class="dripicons-trash" @click="pilih(dt, 0)"></i></td>
                                                                </tr>
                                                                </template>                                                        
                                                            
                                                        </template>
                                                            
                                                            <tr>
                                                                
                                                                <td>
                                                                    <h6>Jumlah :</h6>
                                                                </td>
                                                                <td></td>
                                                                <td></td>
                                                                <td class="text-dark text-right"><strong>{{$zutil.currency(total_pilih)}}   </strong></td>
                                                                <td></td>
                                                            </tr>                                                    
                                                        </tbody>
                                                    </table>

                                                    <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                                </div><!--end re-table-->

                                            </div><!--end card-body-->
                                            </div>
                                        </div><!--end col--> 


                                        
                                        <div class="col-lg-12" v-if="auth.user.id == 0">
                                            <div class="card" v-if="total_pilih">
                                            <div class="card-header">
                                                <h4 class="card-title"><b class="text-primary">3.</b> Profil Pembayar</h4>
                                                <!-- <p class="text-muted mb-0">Sila Pastikan maklumat dibawah adalah benar dan tepat.</p> -->
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                            <w-flex class="mt2">
                                                <div class="xs6 mr5">
                                                    <w-input  v-model="form.nama" required label="Nama *"  :validators="[validators.required]" /> 
                                                </div>
                                                <div class="xs6">
                                                    <w-input  v-model="form.no_id" required label="No. KP / Pasport / Syarikat *"  :validators="[validators.required]" />  
                                                </div>
                                            </w-flex>
                                            <w-flex class="mt2">
                                                <div class="xs6 mr5">
                                                    <w-input  v-model="form.emel" required label="Emel *"  :validators="[validators.required, validators.email]" /> 
                                                </div>
                                                <div class="xs6">
                                                    <w-input  v-model="form.no_tel" required label="No Tel *"  :validators="[validators.required]" />  
                                                </div>
                                            </w-flex>
                                            <w-flex class="mt2">
                                                <div class="xs12 mr5">
                                                    <w-textarea v-model="form.alamat1" :validators="[validators.required]">Alamat *</w-textarea>
                                                </div>
                                            </w-flex>

                                            <w-button class="my1" @click="caraBayar()" > Teruskan</w-button>
                                                
                                                
                                            </div><!--end card-body-->
                                            </div>
                                        </div><!--end col--> 
                                         
                                        
                                            <!-- -->



                                        </div><!--end card-body--> 

                                    </div><!--end card--> 
                                </div> <!--end col--> 

                                    <!-- -->

                                </div><!--end row-->

                            </div><!--end col-->
                            <div class="col-lg-3">
                                <div class="card" v-if="total_pilih">
                                    <div class="card-header">
                                        <div class="row align-items-center">
                                            <div class="col">                      
                                                <h4 class="card-title"><i class="mdi mdi-cart-outline me-2"></i> Senarai Jenis Pembayaran  Ingin Dibayar</h4>                      
                                            </div><!--end col-->
                                        </div>  <!--end row-->                                  
                                    </div><!--end card-header-->
                                    <div class="card-body">
                                        <div class="text-center">
                                            <div id="ana_device" class="apex-charts hide"></div>
                                            
                                        </div>  
                                        <div class="table-responsive mt-2">
                                            <table class="table border-dashed mb-0">
                                                <thead>
                                                <tr>
                                                    <th>Jenis Pembayaran</th>
                                                    <th class="text-end">Jumlah (RM)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="total_cukai_pilih">
                                                    <td>CUKAI</td>
                                                    <td class="text-end"> {{$zutil.currency(total_cukai_pilih)}}</td>
                                                </tr>
                                                <tr v-if="total_perumahan_pilih">
                                                    <td>PERUMAHAN</td>
                                                    <td class="text-end"> {{$zutil.currency(total_perumahan_pilih)}}</td>
                                                </tr>

                                                <tr v-if="total_pendidikan_pilih">
                                                    <td>PENDIDIKAN</td>
                                                    <td class="text-end"> {{$zutil.currency(total_pendidikan_pilih)}}</td>
                                                </tr>
                                                
                                                </tbody><thead>
                                                <tr>
                                                    <th>Jumlah</th>
                                                    <th class="text-end"> {{$zutil.currency(total_pilih)}}</th>
                                                </tr>
                                                </thead>                                           
                                                
                                            </table><!--end /table-->
                                        </div><!--end /div-->                                 
                                    </div><!--end card-body--> 
                                </div><!--end card--> 

                                
                                <div class="card" v-if="cara_bayar">
                                            <div class="card-header">
                                                <h4 class="card-title"> <b class="text-primary">
                                                    <template v-if="auth.user.id == 0">4.</template>
                                                    <template v-else>3.</template>
                                                </b> Cara Pembayaran</h4>
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                            	<div class="d-flex">
                                            <div class="d-block ms-2 align-self-center">
                                                
                                                
                                            </div>
                                        </div>
                                                <div class="accordion accordion-flush checkout-accordion" id="accordionFlushExample">
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingOne">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" @click="pilihCaraTerima(1)">                                               
                                                            <img src="assets/images/cards/card-2.png" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Credit Card</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseOne" class="accordion-collapse collapse show" v-if="form.lkp_cara_terima_id == 1" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <div class="row">  
                                                                <div class="col-md-12">
                                                                    <div class="form-group">
                                                                        <label class="form-label" for="Card_No">Card No :</label>
                                                                        <input type="text" class="form-control form-control-sm" id="Card_No" required="" placeholder="1234-5678-9123-4567">
                                                                    </div>
                                                                </div>  <!--end col-->                               
                                                                <div class="col-md-4">
                                                                    <div class="form-group">
                                                                        <label for="select_month" class="my-2 form-label">Expiry Month</label>
                                                                        <select class="form-select form-select-sm" id="select_month">
                                                                            <option selected="">-- Select --</option>
                                                                            <option value="1">1</option>
                                                                            <option value="2">2</option>
                                                                            <option value="3">3</option>
                                                                            <option value="4">4</option>
                                                                            <option value="5">5</option>
                                                                            <option value="6">6</option>
                                                                            <option value="7">7</option>
                                                                            <option value="8">8</option>
                                                                            <option value="9">9</option>
                                                                            <option value="10">10</option>
                                                                            <option value="11">11</option>
                                                                            <option value="12">12</option>
                                                                        </select>
                                                                    </div>                                    
                                                                </div><!--end col-->  
                                                                <div class="col-md-4">
                                                                    <div class="form-group">
                                                                        <label for="select_year" class="my-2 form-label">Expiry Year</label>
                                                                        <select class="form-select form-select-sm" id="select_year">
                                                                            <option selected="">-- Select --</option>
                                                                            <option value="1">2020</option>
                                                                            <option value="2">2021</option>
                                                                            <option value="3">2022</option>
                                                                            <option value="4">2023</option>
                                                                            <option value="5">2024</option>
                                                                            <option value="6">2025</option>
                                                                        </select>
                                                                    </div>
                                                                </div> <!--end col--> 
                                                                <div class="col-md-4">
                                                                    <div class="form-group">
                                                                        <label class="form-label my-2" for="CVV_Code">Security Code</label>
                                                                        <input type="password" class="form-control form-control-sm" id="CVV_Code" required="" placeholder="Enter CVV">
                                                                    </div>
                                                                </div><!--end col-->
                                                            </div><!--end row-->
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(2)">                                                
                                                            <img src="assets/images/cards/card-6.svg" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Grab Pay</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseTwo" class="accordion-collapse collapse show"  v-if="form.lkp_cara_terima_id == 2" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <p class="mb-0 text-muted">
                                                                Add Grab Pay form page
                                                            </p> 
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(3)">                                                
                                                            <img src="assets/images/cards/card-7.png" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Touch n' Go eWAllet</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseTwo" class="accordion-collapse collapse show" v-if="form.lkp_cara_terima_id == 3" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <p class="mb-0 text-muted">
                                                                Add Touch n' Go form page
                                                            </p> 
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(4)">                                                
                                                            <img src="assets/images/cards/card-8.png" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Boost</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseTwo" class="accordion-collapse collapse show" v-if="form.lkp_cara_terima_id == 4" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <p class="mb-0 text-muted">
                                                                Add Boost form page
                                                            </p> 
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(5)">                                                
                                                            <img src="assets/images/cards/card-9.svg" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">Maybank QRPay</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseTwo" class="accordion-collapse collapse show" v-if="form.lkp_cara_terima_id == 5" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <p class="mb-0 text-muted">
                                                                Add Maybank QRPay form page
                                                            </p> 
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                      <h2 class="accordion-header mt-0" id="flush-headingTwo">
                                                        <button class="accordion-button collapsed d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"  @click="pilihCaraTerima(6)">                                                
                                                            <img src="assets/images/cards/card-10.svg" alt="" height="30">
                                                            <span class="align-self-center ms-2 fw-semibold">FPX</span>
                                                        </button>
                                                      </h2>
                                                      <div id="flush-collapseTwo" class="accordion-collapse collapse show" v-if="form.lkp_cara_terima_id == 6" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <p class="mb-0 text-muted">
                                                                Add FPX form page
                                                            </p> 
                                                        </div>
                                                      </div>
                                                    </div>
                                                </div>                   
                                            </div><!--end card-body-->
                                        </div>


                                        <div class="card" v-if="cara_bayar">
                                            <div class="card-header">
                                                <h4 class="card-title"> Terma & Syarat</h4>
                                                
                                            </div><!--end card-header-->
                                            <div class="card-body">
                                                Disini saya mengesahkan bahawa saya memperakui segala terma dan syarat yang telah ditetapkan oleh pihak kerajaan kedah melalui paltform iBayaq
                                                <br>
                                                <w-checkbox v-model="form.agree">Setuju Terma dan syarat</w-checkbox> <br>
                                                <template v-if="form.agree == true && form.lkp_cara_terima_id != 0 && form.check_amaun != 0">
                                                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent"> Bayar</w-button>
                                                </template>
                                                <template v-else>
                                                    <w-button class="my1" :disabled="true" > Bayar</w-button>
                                                </template>
                                                
                                            </div><!--end card-body-->
                                            </div>
                                            <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
                                        

                            </div> <!--end col--> 

               </template>
                        </div><!--end row-->
                        <!-- -->

                    </div><!--end card-body--> 
                </div>
                

            </div>


        </div>
  	</w-form>
<w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-pencil</w-icon>
       {{dialog.data.sumber_keterangan}}
    </template>
    <div class="page-wrapper-portal">
        <div class="row card-scroll">
            
            <template v-if="dialog.data.lkp_sumber_id == 1" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama :</div>
                          <div class="fw-normal "> 
                            <template v-for="dt, index in dialog.data.detail.pemiliks">
                                <template v-if="index == 0">{{dt.nama}}</template>
                            </template>
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Pejabat Tanah :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.daerah}}
                           </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Alamat :</div>
                          <div class="fw-normal "> 
                            <template v-for="dt, index in dialog.data.detail.pemiliks">
                                <template v-if="index == 0">{{dt.alamat_1}} {{dt.alamat_2}} {{dt.alamat_3}}</template> 
                            </template>
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Daerah :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.kod_daerah}} - {{dialog.data.detail.daerah}}
                           </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0"> Mukim/Bandar/Pekan</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.kod_mukim}} - {{dialog.data.detail.mukim}}
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Tarikh Daftar :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.tarikh_daftar}} 
                           </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0"> Jenis Hakmilik</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.jenis_hm}} - {{dialog.data.detail.jenis_hm_keterangan}}
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">No. Lot :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.no_lot}} 
                           </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0"> No. KP</div>
                          <div class="fw-normal "> 
                            <template v-for="dt, index in dialog.data.detail.pemiliks">
                                <template v-if="index == 0">{{dt.no_km}} </template> 
                            </template>
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Keluasan :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.keluasan}} 
                           </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0"> No. Hakmilik</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.no_hm}} 
                           </div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Kegunaan :</div>
                          <div class="fw-normal "> 
                            {{dialog.data.detail.kegunaan}} 
                           </div>
                    </div>
                </w-flex>

                <div class="table-responsive shopping-cart">
                    <table class="table mb-0">
                        <thead>
                            <tr>
                                <th>Perkara </th>                                                  
                                <th class="border-top-0 text-right">Amaun  (RM)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="dt, index in dialog.data.detail.cukais">
                                <tr>
                                <td>
                                   {{dt.keterangan}} 
                                </td>
                                <td class="text-right">{{dt.amaun_debit}}</td>        
                            </tr>
                        </template>
                            <tr>
                                <th>Jumlah</th>
                                <td class="text-dark text-right"><strong>{{$zutil.currency(dialog.data.amaun)}}   </strong></td>
                            </tr>      
                                                                        
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-if="dialog.data.lkp_sumber_id == 2" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Kod Permis :</div>
                          <div class="fw-normal ">{{dialog.data.detail.KOD_PREMIS}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama Pemilik :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_PEMILIK}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">No Kad Pengenalan (Lama) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.KPLAMA_PEMILIK}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">No Kad Pengenalan (Baru) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.KPBARU_PEMILIK}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama Skim :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_SKIM}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Alamat Skim :</div>
                          <div class="fw-normal ">{{dialog.data.detail.ALAMAT1_RUMAH}} {{dialog.data.detail.ALAMAT2_RUMAH}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.KADAR_ANS_SEWA}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Baki Harga Rumah (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.BAKIRUMAH}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Tunggakan (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.TUNGGAKAN_ASAL}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0"></div>
                          <div class="fw-normal "></div>
                    </div>
                </w-flex>
                
            </template>
            <template v-if="dialog.data.lkp_sumber_id == 3" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">No. LBNK :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NO_LBNK}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama  :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_PENUH}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">No Kad Pengenalan :</div>
                          <div class="fw-normal ">{{dialog.data.detail.IC_BARU}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Alamat</div>
                          <div class="fw-normal ">{{dialog.data.detail.ALAMAT_SURAT}}</div>
                    </div>
                </w-flex>
               
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.ANSURAN_BULANAN}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Baki  (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.JUMLAH_BAKI}}</div>
                    </div>
                </w-flex>
                
                
            </template>

            <template v-if="dialog.data.lkp_sumber_id == 4" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">No Kad Pengenalan :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NOKP_PEMINJAM}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama Peminjam :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_PEMINJAM}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama Syarikat :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_SYARIKAT}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama Skim :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_SKIM}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Ansuran Bulanan (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.ANS_BULANAN}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Pinjaman (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.JUMLAH_PINJAMAN}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.JUMLAH_PERLU_BAYAR}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0"></div>
                          <div class="fw-normal "></div>
                    </div>
                </w-flex>
                
            </template>


            <template v-if="dialog.data.lkp_sumber_id == 7" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Id Pendaftaran :</div>
                          <div class="fw-normal ">{{dialog.data.detail.IDPENDAFTARAN}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">No KP :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NO_KP}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama  :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">KOD :</div>
                          <div class="fw-normal ">{{dialog.data.detail.KOD}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">NO TELEFON :</div>
                          <div class="fw-normal ">{{dialog.data.detail.HP_NO}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">EMEL :</div>
                          <div class="fw-normal ">{{dialog.data.detail.EMAIL}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.JUMLAH_PERLU_BAYAR}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0"></div>
                          <div class="fw-normal "></div>
                    </div>
                </w-flex>
                
            </template>
            <template v-if="dialog.data.lkp_sumber_id == 6" >
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Id Pendaftaran :</div>
                          <div class="fw-normal ">{{dialog.data.detail.ID}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">No KP :</div>
                          <div class="fw-normal ">{{dialog.data.detail.IC}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Nama  :</div>
                          <div class="fw-normal ">{{dialog.data.detail.NAMA_PENUH}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">JENIS :</div>
                          <div class="fw-normal ">{{dialog.data.detail.JENIS}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">NO TELEFON :</div>
                          <div class="fw-normal ">{{dialog.data.detail.TEL_BIMBIT}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0">EMEL :</div>
                          <div class="fw-normal ">{{dialog.data.detail.EMAIL}}</div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center>
                    <div class="xs6">
                          <div class="fw-semibold m0">Jumlah Perlu Bayar (RM) :</div>
                          <div class="fw-normal ">{{dialog.data.detail.AMAUN_PERLU_BAYAR}}</div>
                    </div>
                    <div class="xs6">
                          <div class="fw-semibold m0"></div>
                          <div class="fw-normal "></div>
                    </div>
                </w-flex>
                
            </template>
        </div>
    </div>

      <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      </template>
</w-dialog>
  </layout>
</template>

<script type="text/javascript">
    import Menu from '../Menu.vue'
    import MenuNav from '../MenuNav.vue'

import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
	components: {
	  Menu,MenuNav
	},
	setup () {

	},
    props: {
        auth: [Array, Object],
        butirans : [Array, Object],
    },
	data() {
	    return {
            no_rujukan: '',

            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: ' ',
                precision: 2,
                masked: false
            },
            cara_bayar : 0,
            senarai : [],
            total_carian : 0,
            total_pilih : 0,
            total_cukai_pilih : 0,
            total_perumahan_pilih :0,
            total_pendidikan_pilih : 0,
            cari : 0,
            form : {
                lkp_cara_terima_id : 0,
                check_amaun : 1
            },
            dialog: {
              valid: false,
              show: false,
              fullscreen: false,
              persistent: true,
              persistentNoAnimation: false,
              loading: false,
              width: 800,
              data: {}
            },
    	}
    },
	methods: {
	  carian () {

	  	this.$inertia.visit(window.route('landing.idaftar')+'?no_rujukan='+this.no_rujukan, {preserveState:true, onSuccess: () => {return Promise.all([this.total(),])}})
	  },

      paparan(dt){
        this.dialog.show = 1
        this.dialog.data = dt
      },

	  total(){
	  	 this.total_carian = 0
	  	 this.total_pilih = 0
         this.total_cukai_pilih = 0
         this.total_perumahan_pilih  = 0
         this.total_pendidikan_pilih = 0
         this.form.check_amaun = 1
	  	for (var i in this.butirans) {
	  		if(this.butirans[i].bakul == 1){
	  			this.total_pilih = this.total_pilih + this.butirans[i].amaun_bayar
                if(this.butirans[i].lkp_sumber_id == 1){
                    this.total_cukai_pilih = this.total_cukai_pilih + this.butirans[i].amaun_bayar
                }
                if(this.butirans[i].lkp_sumber_id == 2){
                    this.total_perumahan_pilih = this.total_perumahan_pilih + this.butirans[i].amaun_bayar
                }

                if(this.butirans[i].lkp_sumber_id == 3){
                    this.total_pendidikan_pilih = this.total_pendidikan_pilih + this.butirans[i].amaun_bayar
                }
	  		}else{
	  			this.total_carian = this.total_carian + this.butirans[i].amaun_bayar
	  		}
            if(this.butirans[i].amaun_bayar < this.butirans[i].amaun_min){
                this.form.check_amaun = 0

            }
	  	}
        this.no_rujukan = ''

        if(this.auth.user.id > 0){
            this.caraBayar();
        }
	  },

      caraBayar(){
        this.cara_bayar = 1;
      },

      bayar(){
        this.$zcomm.add('butiran.bayar', this.form)
        .then(res => {
          
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify ("Data Berjaya Dihantar.")
          // if(this.auth.user.id != 0){
              this.$inertia.visit(this.$route('landing.transaksi')+'?resit_id='+res)
          // }else{
          //   this.$inertia.visit(this.$route('landing'))
          // }
          
        })
        .finally(() => {
            
        });
      },

      checkAmaun(dt){

        if(dt.amaun_bayar < dt.amaun_min){
            dt.mesej = 'Amaun Minimun ' + this.$zutil.currency(dt.amaun_min)
        }else{
            dt.mesej = null
        }
        this.total()
      },

	  pilih(dt, bakul){
	  	dt.bakul = bakul
        if(bakul == 0){
            dt.amaun_bayar = dt.amaun
        }
        this.$zcomm.store('butiran.bakul', dt)
        .then(res => {
          
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          if(bakul == 1){
              this.$zutil.notify ("Data Berjaya Ditambahkan.")
          }else{
            this.$zutil.notify ("Data Berjaya Dipadamkan.")
          }
          
        })
        .finally(() => {
            
        });
	  	this.total()
	  },

      pilihCaraTerima(id){
        this.form.lkp_cara_terima_id = id
      }

	},
  mounted() {
    // override default setting
    
    this.total()
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_rujukan){
    	this.no_rujukan = this.cari.no_rujukan
    	this.carian();
    }
  }
}
</script>
<style type="text/css">
	
</style>